<script>
    import {createEventDispatcher} from 'svelte';
    import OrderSelect from "./OrderSelect.svelte";
    import OPTS from "../../libs/options";
    import { query } from "../../libs/stores";

    const dispatch = createEventDispatcher();

    function dispatchSort(event) {
        const sort = event.detail.split(":");
        dispatch("sort", {field: sort[0], order: sort[1]});
    }
</script>

<div class="c-search__row">
    <div id="facets" class="c-facets">
        <div class="c-facets__group">
            <div class="c-facets__label">Ordina per:</div>
            <div class="c-facets__filter">
                <OrderSelect
                        on:filterSelected={dispatchSort}
                        on:filterUnselected={dispatchSort}/>
            </div>
        </div>
    </div>

    {#if !OPTS.disable.reset}
        <div class="c-search__reset c-buttons">
            <div class="c-button c-button--raised">
                <a href="#" on:click|preventDefault={() => query.clear()}>Resetta filtri</a>
            </div>
        </div>
    {/if}
</div>